import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, filter, map, take, takeUntil } from 'rxjs';
import { DataSourceControlService } from '../data-source-utils/data-source-control.service';
import { FormControlService } from '../form-control.service';
import { FormControlServiceBase } from '../types/form-control-service.base';
import { IDisposable } from '../types/i-disposable';
import { FormControlUtils } from '../utils/form-control.utils';
import { ISelectFormControlOptions } from './types/i-select-form-control.options';


export type MatTemplateType = 'basic' | 'fromTemplateRef' | 'fromTemplate'

@Injectable()
export class SelectFormControlService extends DataSourceControlService implements FormControlServiceBase<'select'> {


  readonly listItemsSubject = new BehaviorSubject<ISelectFormControlOptions['listItems']>(undefined);
  readonly formControlSubject = this._formControlService.formControlSubject;

  readonly dataObs = combineLatest([
    this.listItemsSubject,
    this.dataSubject
  ])
    .pipe(
      map(dataTuple => dataTuple.find(arr => arr?.length))
    )

  readonly disposables: IDisposable[] = [];
  constructor(
    private _formControlService: FormControlService,

  ) {

    super();


    this.formControlSubject

      .pipe(
        filter(Boolean),
        take(1),
        takeUntil(this._destroy)
      )
      .subscribe((formControl) => {

        const optionsInstance = formControl.options;
        const disposables = FormControlUtils.mapControlOptionsToService(optionsInstance, this);

        if (!disposables) {
          return;
        }

        this.disposables.push(...disposables)

      })


    this.valueSubject
      .pipe(takeUntil(this._destroy))
      .subscribe((value) => {
        this._formControlService.valueSubject.next(value)
      }
      )


  }

  ngOnDestroy() {

    this._destroy.next();
    this._destroy.complete();
    this.disposables.forEach((disposable) => disposable.dispose());
    super.dispose();
  }

}
